import { graphql } from "msw";

import {
  CoPurchasedProductsQuery,
  CoPurchasedProductsQueryVariables,
} from "@personalisation/generated/graphql";

import { mockCopurchasedProducts } from "./CoPurchasedRecommender.mock";

export const handler = graphql.query<
  CoPurchasedProductsQuery,
  CoPurchasedProductsQueryVariables
>("CoPurchasedProducts", (request, response, context) => {
  if (request.variables.includeClubProducts) {
    return response(
      context.data({
        __typename: "Query" as const,
        coPurchasedProducts: {
          products: [
            {
              ...mockCopurchasedProducts.coPurchasedProducts.products[0],
              title: "Some club exclusive product",
            },
          ],
          metaData: {
            hydrationErrorCount: 0,
            preHydrationCount: 1,
            postHydrationCount: 1,
          },
        },
      })
    );
  }
  return response(
    context.data({
      __typename: "Query" as const,
      ...mockCopurchasedProducts,
    })
  );
});
